import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { NdcCommercialFaqPage } from 'src/app/model/page/group/faq/ndc-commercial-faq-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-ndc-commercial-faq-page',
  templateUrl: './ndc-commercial-faq-page.component.html',
  styleUrls: ['./ndc-commercial-faq-page.component.scss']
})
export class NdcCommercialFaqPageComponent implements OnInit {
  ndcCommercialFaqPage: NdcCommercialFaqPage = {} as NdcCommercialFaqPage;
  BackLinkTitle: string = '';
  BackLinkURL: string = '';
  BackLinkIcon: string = '';

  constructor(private contentfulService: ContentfulService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'faq-commercial') {
        this.ndcCommercialFaqPage.htmlTitle = title.htmlTitle;
      }
    });
    this.ndcCommercialFaqPage.sections = [];
    const query = { 'fields.title': 'NDC Commercial Frequently Asked Questions' };
    this.contentfulService.getPageContentWithEntries(query).then((ndcCommercialFaqPageEntries) => {
      this.mapBanner(ndcCommercialFaqPageEntries);
      this.mapSections(ndcCommercialFaqPageEntries);
    });
    this.contentfulService.getPageContentWithItems(query).then((linkItems) => {
      this.BackLinkTitle = linkItems[0]?.fields.constants[0].BackLinkTitle;
      this.BackLinkURL = linkItems[0]?.fields.constants[0].BackLinkURL;
      this.BackLinkIcon = linkItems[0]?.fields.constants[0].BackLinkIcon;
      this.ndcCommercialFaqPage.htmlTitle = linkItems[0].fields.htmlTitle;
    });
  }
  private mapBanner(ndcCommercialFaqPageEntries: Entry<any>[]) {
    ndcCommercialFaqPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let image: any = entry.fields['image'] as string;
    this.ndcCommercialFaqPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: image.fields.file.url
    };
  }
  private mapSections(ndcCommercialFaqPageEntries: Entry<any>[]) {
    ndcCommercialFaqPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
      });

    this.ndcCommercialFaqPage.sections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToSection(entry: Entry<any>) {
    let givenTitle: any = entry.fields['title'] as string;
    let pageTitle = givenTitle.split('#')[2];

    this.ndcCommercialFaqPage.sections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number
    });
  }
}
